<template>
	<div class="con-1334 box-white mt-30px questions">

        <div class="question" v-if="computedCurrent === 0">
            <div class="question__title">
                Van társasház biztosítás?
                <span
                    v-tooltip="
						'Kérjük, adja meg, hogy van-e a társasházának biztosítása.'
					"
                    class="info"
                ></span>
            </div>
            <div class="question__form form">
                <div class="question__buttons">
                    <CalcElem
                        name="hasCondominiumInsurance"
                        :options="{
							label: 'Van a társasházának biztosítása?',
							type: 'radio',
							choices: {
								false: 'Nincs',
								true: 'Van',
							},
							rules: 'required',
							inputGroup: 'questionAnswers',
							hasLabel: false,
							inputclass: 'question-radio',
							inputWrapperClass: 'mobile-break',
						}"
                    />
                </div>
                <div v-if="showCondominiumInsurance">
                    <div class="question__buttons">
                        <CalcElem
                            name="condominiumInsurer"
                            :options="{
                                label: 'Melyik biztosítónál?',
                                type: 'select',
                                choices: this.insurerShortNames,
                                className: 'mw-500px d-table',
                                wrapperClass: '',
                                inputClass: 'w-100 mt-30px mobile-width-full',
                                inputGroup: 'questionAnswers',
                                rules: 'required',
                                hasValue: true
                            }"
                        />
                    </div>
                </div>
            </div>
            <div class="navBtn w-100">
                <button
                    class="navBtn-next btn btn-blue min"
                    @click="handleNext(1)"
                    :disabled="getData('hasCondominiumInsurance') === null && !getData('hasCondominiumInsurance')"
                >
                    Tovább
                </button>
            </div>
        </div>

        <div class="question" v-if="computedCurrent === 1">
			<div class="question__title">
				Jelenleg is van biztosítás az ingatlanra?
				<span
					v-tooltip="
						'Kérjük, adja meg, hogy új szerződést köt vagy meglévő szerződését felmondva kívánja átkötni a szerződését.'
					"
					class="info"
				></span>
			</div>
			<div class="question__form form">
				<div class="question__buttons">
					<CalcElem
						name="isNewContract"
						:options="{
							label: 'Jelenleg is van biztosítás az ingatlanra?',
							type: 'radio',
							choices: {
								true: 'Nincs',
								false: 'Van',
							},
							rules: 'required',
							inputGroup: 'questionAnswers',
							hasLabel: false,
							inputclass: 'question-radio',
							inputWrapperClass: 'mobile-break',
						}"
					/>
				</div>
			</div>
			<div class="navBtn w-100">
                <button class="navBtn-prev min" @click="handlePrev" v-if="isCondominiumType">Előző</button>
				<button
					class="navBtn-next btn btn-blue min"
					@click="handleNext(2)"
					v-if="!getData('isNewContract')"
					:disabled="getData('isNewContract') === null && !getData('isNewContract')"
				>
					Tovább
				</button>
			</div>
            <p class="bottom-info" v-if="getData('isNewContract')">
                Kérjük, töltse ki az alábbi adatokat és utána nyomja meg a TOVÁBB gombot!
            </p>
		</div>

		<div class="question" v-if="computedCurrent === 2">
			<div class="question__title">
				Rendelkezett-e a szerződéskötést megelőző 24 hónapban megszakítás nélkül lakásbiztosítással?
			</div>
			<div class="question__form form">
				<div class="question__buttons">
					<CalcElem
						name="twoYear"
						:options="{
							label: 'Rendelkezett-e 24 hónapban lakásbiztosítással',
							type: 'radio',
							choices: {
								true: 'Igen',
								false: 'Nem',
							},
							rules: '',
							hasLabel: false,
							inputGroup: 'questionAnswers',
						}"
					/>
				</div>
			</div>

			<div class="navBtn w-100">
				<button class="navBtn-prev min" @click="handlePrev">Előző</button>
				<button
					class="navBtn-next btn btn-blue min"
					@click="handleNext(3)"
					:disabled="getData('twoYear') === null"
				>
					Tovább
				</button>
			</div>
		</div>

		<div class="question" v-if="computedCurrent === 3">
			<div class="question__title">Jelenlegi szerződése Minősített Fogyasztóbarát Otthonbiztosítás?</div>
			<div class="question__form form">
				<div class="question__buttons">
					<CalcElem
						name="isMfo"
						:options="{
							label: 'Jelenlegi szerződése MFO',
							type: 'radio',
							choices: {
								true: 'Igen',
								false: 'Nem',
							},
							rules: '',
							hasLabel: false,
							inputGroup: 'questionAnswers',
						}"
					/>
				</div>
			</div>
			<div class="navBtn w-100">
				<button class="navBtn-prev min" @click="handlePrev">Előző</button>
				<button
					class="navBtn-next btn btn-blue min"
					@click="handleNext(4)"
					:disabled="getData('isMfo') === null"
				>
					Tovább
				</button>
			</div>
		</div>

		<div class="question" v-if="computedCurrent === 4">
			<div class="question__title">Meglévő szerződésemet erre az időpontra mondhatom fel:</div>
			<div class="question__form w-100 form">
				<CalcElem
					name="startOfRisk"
					:options="{
						label: 'Meglévő szerződésemet erre az időpontra mondhatom fel',
						type: 'date',
						className: 'mw-500px',
						wrapperClass: 'm-auto mb-8px mt-20px mw-500px w-100',
						inputGroup: 'questionAnswers',
						rules: 'required|day_before_60',
						hasLabel: false,
						min: 0,
					}"
				/>
			</div>
			<p class="bottom-info text-justify mw-1021" v-if="getData('isMfo')">
				Amennyiben jelenleg MFO biztosítása van, akkor az legkorábban a biztosítás kezdetét követő negyedik
				naptári negyedév végére mondható fel joghatályosan.
				<br />
				1. példa: Jelenlegi MFO szerződés kezdete: 2021.07.11.
				<br />
				Az 1. évet követő (2022.07.11) első naptári negyedév vége, amelyre először felmondható a szerződés:
				2022.09.30
				<br />
				2. példa: Jelenlegi MFO szerződés kezdete: 2021.06.02
				<br />
				Az 1. évet követő (2022.06.02) első naptári negyedév vége, amelyre először felmondható a szerződés:
				2022.06.30
				<br />
				Amennyiben az Ön jelenlegi MFO biztosításának kezdete óta már eltelt négy naptári negyedév, akkor
				bármely ezután következő naptári „negyedévfordulóra” felmondhatja, tehát március 31-re, június 30-ra,
				szeptember 30-ra, vagy december 31-re. Praktikusan tehát ez azt jelenti, hogy MFO esetén a második évtől
				kezdődően nem évente, hanem negyedévente mondható fel a lakásbiztosítási szerződés, azaz nem kell egy
				újabb biztosítási évfordulóig várni, ha a váltás mellett döntünk.
				<br />
				A felmondásnak minden esetben legkésőbb a naptári „negyedévfordulót” megelőző 30. napig meg kell
				érkeznie a biztosítóhoz!
			</p>
			<p class="bottom-info" v-if="!getData('isMfo')">
				Amennyiben jelenlegi szerződése „hagyományos” (nem MFO) lakásbiztosítás, akkor a jelenlegi szerződés a
				biztosítási évforduló időpontjára mondható fel. A felmondásnak legkésőbb az évfordulót megelőző 30.
				napig meg kell érkeznie a biztosítóhoz!
			</p>
			<div class="navBtn w-100">
				<button class="navBtn-prev min" @click="handlePrev">Előző</button>
				<button
					class="navBtn-next btn btn-blue min"
					@click="handleNext(5)"
					:disabled="startOfRiskButtonIsDisabled"
				>
					Tovább
				</button>
			</div>
		</div>

		<div class="question" v-if="computedCurrent === 5">
			<div class="question__title">Jelenlegi biztosító neve:</div>
			<div class="question__form w-100 form">
				<CalcElem
					name="insurer"
					:options="{
						label: 'Válaszon a listából',
						type: 'select',
						choices: computedChoices,
						className: 'mw-500px',
						wrapperClass: 'm-auto mb-8px mt-20px mw-500px w-100',
						inputGroup: 'questionAnswers',
						rules: 'required',
						hasLabel: false,
					}"
				/>
			</div>

            <div class="question__title mt-20px">Kérjük, adja meg a jelenlegi lakásbiztosítási szerződése kötvényszámát:</div>
            <div class="question__form w-100 form">
                <CalcElem
                    name="bondNumber"
                    :options="{
                        label: 'Kötvényszám',
                        placeholder: 'Kötvényszám',
						type: 'text',
						className: 'mw-500px uglyfix-class-fixme-please',
						wrapperClass: 'm-auto mb-8px mt-20px mw-500px w-100',
						inputGroup: 'questionAnswers',
						rules: 'required'
					}"
                />
            </div>

			<p class="bottom-info mw-1021 text-justify" v-if="getData('isMfo')">
				Amennyiben jelenleg MFO biztosítása van, akkor az legkorábban a biztosítás kezdetét követő negyedik
				naptári negyedév végére mondható fel joghatályosan.
				<br />
				1. példa: Jelenlegi MFO szerződés kezdete: 2021.07.11.
				<br />
				Az 1. évet követő (2022.07.11) első naptári negyedév vége, amelyre először felmondható a szerződés:
				2022.09.30
				<br />
				2. példa: Jelenlegi MFO szerződés kezdete: 2021.06.02
				<br />
				Az 1. évet követő (2022.06.02) első naptári negyedév vége, amelyre először felmondható a szerződés:
				2022.06.30
				<br />
				Amennyiben az Ön jelenlegi MFO biztosításának kezdete óta már eltelt négy naptári negyedév, akkor
				bármely ezután következő naptári „negyedévfordulóra” felmondhatja, tehát március 31-re, június 30-ra,
				szeptember 30-ra, vagy december 31-re. Praktikusan tehát ez azt jelenti, hogy MFO esetén a második évtől
				kezdődően nem évente, hanem negyedévente mondható fel a lakásbiztosítási szerződés, azaz nem kell egy
				újabb biztosítási évfordulóig várni, ha a váltás mellett döntünk.
				<br />
				A felmondásnak minden esetben legkésőbb a naptári „negyedévfordulót” megelőző 30. napig meg kell
				érkeznie a biztosítóhoz!
			</p>
			<p class="bottom-info" v-if="!getData('isMfo')">
				Amennyiben jelenlegi szerződése „hagyományos” (nem MFO) lakásbiztosítás, akkor a jelenlegi szerződés a
				biztosítási évforduló időpontjára mondható fel. A felmondásnak legkésőbb az évfordulót megelőző 30.
				napig meg kell érkeznie a biztosítóhoz!
			</p>
			<div class="navBtn w-100">
				<button class="navBtn-prev min" @click="handlePrev">Előző</button>
                <button
                    class="navBtn-next btn btn-blue min"
                    @click="handleNext(6)"
                    :disabled="getData('bondNumber') === null || getData('insurer') === null"
                >
                    Tovább
                </button>
			</div>
		</div>
        <div class="question" v-if="computedCurrent === 6">
            <div class="question__title" v-if="diffStartOfRisk < 31 && !getIsBusinessProcess">
                A jelenlegi lakásbiztosítási szerződésének felmondásáról Önnek kell gondoskodnia.
            </div>
            <div class="question__title" v-if="diffStartOfRisk > 30">
                A meglévő lakásbiztosítási szerződés felmondásáról az ügyfél megbízása alapján az Eurorisk Kft. gondoskodik.
            </div>
            <div class="d-flex form justify-center mt-30px question__form w-100" v-if="diffStartOfRisk < 30">
                <CalcElem
                    name="onMyOwn"
                    :options="{
						label: checkboxText,
						type: 'checkbox',
						className: 'mw-500px',
						wrapperClass: 'col-w100-chbox chbox_style-wrapper',
						prop: 'onMyOwn',
						rules: { required: { allowFalse: false } },
					}"
                />
            </div>
            <p class="bottom-info mw-1021 text-justify" v-if="getData('isMfo')">
                Amennyiben jelenleg MFO biztosítása van, akkor az legkorábban a biztosítás kezdetét követő negyedik
                naptári negyedév végére mondható fel joghatályosan.
                <br />
                1. példa: Jelenlegi MFO szerződés kezdete: 2021.07.11.
                <br />
                Az 1. évet követő (2022.07.11) első naptári negyedév vége, amelyre először felmondható a szerződés:
                2022.09.30
                <br />
                2. példa: Jelenlegi MFO szerződés kezdete: 2021.06.02
                <br />
                Az 1. évet követő (2022.06.02) első naptári negyedév vége, amelyre először felmondható a szerződés:
                2022.06.30
                <br />
                Amennyiben az Ön jelenlegi MFO biztosításának kezdete óta már eltelt négy naptári negyedév, akkor
                bármely ezután következő naptári „negyedévfordulóra” felmondhatja, tehát március 31-re, június 30-ra,
                szeptember 30-ra, vagy december 31-re. Praktikusan tehát ez azt jelenti, hogy MFO esetén a második évtől
                kezdődően nem évente, hanem negyedévente mondható fel a lakásbiztosítási szerződés, azaz nem kell egy
                újabb biztosítási évfordulóig várni, ha a váltás mellett döntünk.
                <br />
                A felmondásnak minden esetben legkésőbb a naptári „negyedévfordulót” megelőző 30. napig meg kell
                érkeznie a biztosítóhoz!
            </p>
            <p class="bottom-info" v-if="!getData('isMfo')">
                Amennyiben jelenlegi szerződése „hagyományos” (nem MFO) lakásbiztosítás, akkor a jelenlegi szerződés a
                biztosítási évforduló időpontjára mondható fel. A felmondásnak legkésőbb az évfordulót megelőző 30.
                napig meg kell érkeznie a biztosítóhoz!
            </p>
            <div class="navBtn w-100">
                <button class="navBtn-prev min" @click="handlePrev">Előző</button>
            </div>
            <p class="bottom-info" v-if="diffStartOfRisk > 30 || (diffStartOfRisk < 31 && $store.state.onMyOwn)">
                Kérjük, töltse ki az alábbi adatokat és utána nyomja meg a TOVÁBB gombot!
            </p>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
import Insurers from '@json/Insurers.json';
import MfoInsurers from '@json/MfoInsurers.json';
import InsurersShortName from '@json/InsurersShortName.json';
export default {
	mounted() {
        this.handleNext(this.guessCurrentStep());
	},
	data() {
		return {
			current: 0,
			terminationPattern: null,
		};
	},
	computed: {
		...mapGetters('contracting', ['getBrokerageData']),
		...mapGetters(['getQuestionAnswers', 'getRealEstate', 'getCurrentStep','getIsBusinessProcess','getStateData', 'getRealEstate']),
		computedChoices() {
			return this.getData('isMfo')
				? MfoInsurers
				: Insurers;
		},
		getData() {
			return key => this.getQuestionAnswers[key] ?? null;
		},
		computedCurrent() {
			return this.current;
			//return this.$store.state.onMyOwn ? 5 : this.current;
		},
		startOfRiskOk() {
			const startOfRisk = moment(this.getStateData("calculation").start_of_risk);
			return startOfRisk.isAfter(moment(this.$store.state.questionAnswers.startOfRisk), 'days');
		},
        diffStartOfRisk() {
            const startOfRisk = moment(this.$store.state.questionAnswers.startOfRisk);
            return startOfRisk.diff(moment(), 'days');
        },
		startOfRiskButtonIsDisabled() {
			const dateValue = moment(this.getData('startOfRisk')).subtract(60, 'days');
			const result = moment().isSameOrBefore(dateValue);

			return this.getData('startOfRisk') === null || result;
		},
        showCondominiumInsurance() {
            return this.getData('hasCondominiumInsurance')
        },
        checkboxText() {
            if(this.getIsBusinessProcess)
                return 'A felmondás beküldéséről intézkedni fogok!';

            if (this.diffStartOfRisk < 31) {
                return 'A meglévő biztosítási szerződésem határidőre történő felmondásáról a jelenlegi biztosító felé intézkedtem!';
            }
        },
        isCondominiumType() {
            return this.getRealEstate.type === 0;
        },
        insurerShortNames(){
            return InsurersShortName;
        }
	},
	methods: {
		...mapMutations(['setInputData', 'setOldContractLastStep', 'clearCalculationStart_of_risk']),
		handlePrev() {
            if(this.current === 6) {
                this.setOldContractLastStep(false);
            }
			this.current = this.current - 1;
		},
		handleNext(next) {
            if (next === 6) {
                if(!this.startOfRiskOk) {
                    this.clearCalculationStart_of_risk();
                }
                this.setOldContractLastStep(true);
            }
			this.current = next;
		},
        guessCurrentStep() {
            if(this.isCondominiumType && (this.getData('hasCondominiumInsurance') === null || ( this.getData('hasCondominiumInsurance') === true && this.getData('condominiumInsurer') === null ) )) {
                return 0;
            }

            if(this.getData('isNewContract') === null || this.getData('isNewContract')) {
                return  1;
            }

            if(this.getData('twoYear') === null) {
                return  2;
            }

            if(this.getData('isMfo') === null) {
                return 3;
            }

            if(this.getData('startOfRisk') === null) {
                return 4;
            }

            if(this.getData('bondNumber') === null || this.getData('insurer') === null) {
                return 5;
            }

            return 6;
        },
	}
};
</script>

<style lang="scss" scoped>
.questions {
	padding: 30px;
	position: relative;

	.pdf {
		font-size: 12px;
		line-height: 16px;
		color: #1068eb;
	}

	p.mw-1021 {
		max-width: 1021px;
	}

	.bottom-info {
		font-family: Arial;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 16px;
		color: #1f2835;
		margin-top: 30px;
	}

	.question {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: relative;

		.question__prev {
			position: absolute;
			top: -15px;
			left: -10px;
			color: #6a7178;
			cursor: pointer;

			&:hover {
				text-decoration: underline;
			}
		}

		&__title {
			display: flex;
			justify-content: center;
			align-items: center;

			.question__prev {
				position: absolute;
				top: 10px;
				left: 15px;
				color: #6a7178;
				cursor: pointer;

				&:hover {
					text-decoration: underline;
				}
			}

			.question__next {
				position: absolute;
				top: 10px;
				right: 15px;
				color: #6a7178;
				cursor: pointer;

				&:hover {
					text-decoration: underline;
				}
			}

			span.info {
				margin-left: 10px;
				display: flex;
				align-items: center;
				right: -30px;
				top: 0;

				&::after {
					content: 'ⓘ';
					height: 13px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 16px;
					color: color(secondary, color07);
					cursor: pointer;
				}
			}
		}

		&__buttons {
			display: flex;
			margin-top: 15px;

			button {
				padding: 12px 36px;
				background: white;
				border: 1px solid #ced4da;
				font-family: Arial;
				font-style: normal;
				font-weight: normal;
				font-size: 16px;
				line-height: 24px;
				color: #6a7178;
				cursor: pointer;
				transition: 0.3s;

				&.left {
					border-top-left-radius: 4px;
					border-bottom-left-radius: 4px;
				}

				&.right {
					border-top-right-radius: 4px;
					border-bottom-right-radius: 4px;
				}

				&:hover {
					border: 1px solid #1068eb;
					color: #1068eb;
				}

				&:active {
					background: #1068eb;
					color: white;
					border: 1px solid #1068eb;
				}

				&.selected {
					background: #1068eb;
					color: white;
					border: 1px solid #1068eb;
				}
			}
		}
	}
}
</style>
